import { ReactElement } from 'react';
import GrispiLoadingLayout from '../../../src/layouts/GrispiLoadingLayout';
import MainLayout from '../../../src/layouts/MainLayout';
import TicketDetailContentLayout from '../../../src/layouts/Pages/TicketPagesContentLayout/TicketDetailContentLayout';
import { userRolesMap } from '../../../src/model/types';
import GSocialStatusProvider from '../../../src/store/provider/GSocialStatusProvider';

export default function PageByTicketId() {
    return (
        <GSocialStatusProvider>
            <TicketDetailContentLayout />
        </GSocialStatusProvider>
    );
}

PageByTicketId.getLayout = function getLayout(page: ReactElement) {
    return <MainLayout>{page}</MainLayout>;
};

PageByTicketId.auth = {
    role: userRolesMap.ROLE_AGENT,
    loading: <GrispiLoadingLayout />
};
